import React from 'react';
import { Col, Radio, RadioChangeEvent, Row } from 'antd';

interface ViewPickerProps {
  userSecret: string;
  viewSelected: string;
  onViewSelectedChange: (userSecret: string, value: string) => void;
}

const ViewPickerComponent: React.FC<ViewPickerProps> = ({
  userSecret,
  viewSelected,
  onViewSelectedChange,
}) => {
  const handleChange = (e: RadioChangeEvent) => {
    onViewSelectedChange(userSecret, e.target.value);
  };

  return (
    <Row justify='center'>
      <Col span={24} style={{ textAlign: 'center' }}>
        <Radio.Group
          className='view-selector-holder'
          onChange={handleChange}
          value={viewSelected}
        >
          <Radio.Button className='slctr-btn' value='visited'>
            Visited
          </Radio.Button>
          <Radio.Button className='slctr-btn' value='want-to-visit'>
            Want To Visit
          </Radio.Button>
        </Radio.Group>
      </Col>
    </Row>
  );
};

export default ViewPickerComponent;
